import React, { useContext } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { Event } from 'schema-dts';
import { useTranslatableField } from '@/utils/useTranslatableField';
import Head from 'next/head';
import { SurveyType } from 'types/survey';
import { PageContext } from 'src/context/PageContext';

interface SurveyProps {
  survey: SurveyType;
}
export function SurveyStructuredData(props: SurveyProps): JSX.Element | null {
  const { survey } = props;
  const { slug } = useContext(PageContext);
  const { translateField } = useTranslatableField(slug?.[1]);
  if (survey?.noindex) {
    return (
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
    );
  }
  return (
    <Head>
      <script
        key="structured-data"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...jsonLdScriptProps<Event>({
          '@context': 'https://schema.org',
          '@type': 'Event',
          name: translateField(survey?.title_for_display),
          startDate: survey?.start_time,
          endDate: survey?.end_time || '',
          description: translateField(survey?.configuration?.description),
          location: 'online',
        })}
      />
    </Head>
  );
}
